export const environment = {
  postgrestBaseUrl: 'https://servreg.dev.desp.space/api',
  fileSystemBaseUrl: 'https://servreg.dev.desp.space/fs/serviceMedia',
  fileSystemMediaBaseUrl: 'https://servreg.dev.desp.space/fs/generalMedia',
  fileSystemDocBaseUrl: 'https://servreg.dev.desp.space/fs/docfiles',
  //fileSystemDocBaseUrl: 'http://localhost:8080/docfiles',
  logsUrl: 'https://servreg.dev.desp.space/desp-servreg-logs',
  keycloakUrl: 'https://iam.ivv.desp.space/',
  realm: 'desp',
  clientId: 'srvregbe_public',
  enableLogging: true
};
